import React from 'react';

import * as S from './styles';

const Gallery07: React.FC = () => {
  return (
    <S.Container>
      <S.Wrapper>
        <S.Photo1
          className="wow animate__animated animate__fadeIn"
          data-wow-duration="1s"
          data-wow-delay="200ms"
        />
        <S.Caption className="mobile">
          <p>
            Detalhe de âncora em desenho sem título de Tom Of Finland, de 1962.
            Foto: reprodução do livro “Tom of Finland – Bikers II”.
          </p>
        </S.Caption>
        <S.Photo2
          className="wow animate__animated animate__fadeIn"
          data-wow-duration="1s"
          data-wow-delay="400ms"
        />
        <S.Caption className="mobile">
          <p>
            Marinheiro da coleção de verão 2023 de Thom Browne. | Foto Getty
            Images.
          </p>
        </S.Caption>
      </S.Wrapper>
      <S.Caption className="desktop">
        <p>
          À esq., detalhe de âncora em desenho sem título de Tom Of Finland, de
          1962 (reprodução do livro “Tom of Finland – Bikers II”); à dir.,
          marinheiro da coleção de verão 2023 de Thom Browne (Getty Images).
        </p>
      </S.Caption>
    </S.Container>
  );
};

export default Gallery07;
